import { PageHeader, Space, Tabs } from "antd";
import React from "react";
import { NavLink, RouteChildrenProps, useHistory } from "react-router-dom";

import { Feature, Home } from "../components/Workspace";

const pageTitle = "Workspace Settings";

const pathsToTabs: { [key: string]: string } = {
  "/": "general",
  "/workspace_settings/features": "features",
};

const WorkspaceSettingsView: React.FunctionComponent<RouteChildrenProps> = ({
  match,
}) => {
  const activeTab = pathsToTabs[match!.path] ?? "general";
  const history = useHistory();
  const handleTabChange = (activeKey: string) => {
    switch (activeKey) {
      case "general":
        history.push("/workspace_settings/");
        break;
      default:
        history.push(`/workspace_settings/${activeKey}`);
        break;
    }
  };
  return (
    <React.Fragment>
      <PageHeader
        breadcrumb={{
          itemRender: (route, params) => (
            <NavLink to={route.path} {...params}>
              {route.breadcrumbName}
            </NavLink>
          ),
          routes: [
            {
              path: "/",
              breadcrumbName: "Home",
            },
            {
              path: match!.path,
              breadcrumbName: pageTitle,
            },
          ],
        }}
        style={{ backgroundColor: "#fff" }}
        title={pageTitle}
      />
      <Space
        direction="vertical"
        size={16}
        style={{ width: "100%", padding: "24px" }}
      >
        <Tabs
          activeKey={activeTab}
          items={[
            {
              key: "general",
              label: "General",
              children: <Home />,
            },
            {
              key: "features",
              label: "Feature Flags",
              children: <Feature />,
            },
          ]}
          onChange={handleTabChange}
        />
      </Space>
    </React.Fragment>
  );
};
export default WorkspaceSettingsView;
